class FalconFaq extends HTMLElement {
  connectedCallback() {
    if (this.lifecycleController) return;

    this.lifecycleController = new AbortController();
    this.items = [...this.querySelectorAll('[data-faq-item]')];

    this.items.forEach((item) => {
      item.querySelector('[data-faq-trigger]')?.addEventListener(
        'click',
        () => this.toggleItem(item),
        { signal: this.lifecycleController.signal }
      );
    });
  }

  toggleItem(selectedItem) {
    const shouldOpen = !selectedItem.classList.contains('is-open');

    this.items.forEach((item) => {
      const isOpen = item === selectedItem && shouldOpen;
      item.classList.toggle('is-open', isOpen);
      item.querySelector('[data-faq-trigger]')?.setAttribute('aria-expanded', String(isOpen));
      item.querySelector('[data-faq-content]')?.setAttribute('aria-hidden', String(!isOpen));
    });
  }

  disconnectedCallback() {
    this.lifecycleController?.abort();
    this.lifecycleController = null;
    this.items = [];
  }
}

if (!customElements.get('falcon-faq')) {
  customElements.define('falcon-faq', FalconFaq);
}
